<template>
  <div>
    <loginHeader></loginHeader>
    <loginFooter></loginFooter>
    <div class="login_bg" id="login_bg">
      <h3>找回密码</h3>
      <el-input
        maxlength="11"
        class="input"
        placeholder="请输入手机号码"
        prefix-icon="el-icon-mobile-phone"
        v-model="phone_num"
        clearable
        @blur="verification_mobile"
      ></el-input>
      <el-input
        maxlength="6"
        class="input"
        placeholder="请输入手机验证码"
        prefix-icon="el-icon-circle-check"
        v-model="verification_code"
      ></el-input>
      <div @click="getVerifcation" class="get-code" id="_countdown">点击获取验证码</div>
      <div id="_error_" class="error-text"></div>
      <div @click="success" class="login_btn">下一步</div>
      <div @click="login()" class="return_login"> 
        返回登录
      </div>
    </div>
    <div class="confirm_password" id="confirm_password">
      <h3>找回密码</h3>
      <el-input
        type="password"
        maxlength="16"
        class="input"
        placeholder="请输入6-16位字符，至少包含字母和数字。"
        prefix-icon="el-icon-mobile-phone"
        v-model="pwd"
        clearable
        @blur="verdict_pwd"
      ></el-input>
      <el-input
        type="password"
        maxlength="16"
        class="input"
        placeholder="确认密码"
        prefix-icon="el-icon-circle-check"
        v-model="password1"
      ></el-input>
      <div id="_error1_" class="error-text"></div>
      <div @click="finish" class="login_btn" id="login_btn">完成</div>
    </div>
  </div>
</template>

<script>
import { validateTel, validatePwd } from "@/utils/validate";
import { showError,showError1, addErrorClass } from "@/utils/common";
export default {
  components: {
    loginHeader: () =>
      import(/* webpackChunkName: "design" */ "../components/login_header"),
      loginFooter: () =>
      import(/* webpackChunkName: "design" */ "../components/login_footer")
  },
  data() {
    return {
      phone_num: "",
      pwd: "",
      password1: "",
      verification_code: ""
    };
  },
  methods: {
    verification_mobile() {
      const mobile = this.phone_num;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error_", !0);
      }else{
        showError("");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      }
    },
    verdict_pwd(){
       const affirm_pwd=this.pwd;
      if(!validatePwd(affirm_pwd)){
        showError1("密码格式不正确");
        addErrorClass("error-text");
        addErrorClass("_error_", !0);
      }else{
        showError1("");
        addErrorClass("_error_");
        addErrorClass("error-text",!0);
      }
    },
    login() {
      this.$router.push({
        path: `/`
      });
    },
    success() {
      const mobile = this.phone_num;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error_", !0);
      }
      else {
        $("#login_bg").hide();
        $("#confirm_password").show();
      }
    },
    getVerifcation() {
      const mobile = this.phone_num;
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_input_");
        addErrorClass("_error1_", !0);
      } else {
        $("#_countdown").click(function(event) {
          //这里写发送验证码的代码
          $("#_error1_").hide();
          var time = 60;
          settime($("#_countdown"));
          function settime(obj) {
            if (time == 0) {
              $("#_countdown").attr("disabled", false);
              $("#_countdown").html("点击获取验证码");
              time = 60;
              return;
            } else {
              $("#_countdown").attr("disabled", true);
              $("#_countdown").html(time + "s");
              time--;
              $("#_countdown_").addClass("notclick");
            }
            setTimeout(function() {
              settime(obj);
            }, 1000);
          }
        });
      }
    },
    finish() {
      const mobile = this.phone_num;
      const password = this.pwd;
      const password1 = this.password1;
      if (!validatePwd(password)) {
        showError1("密码格式不正确");
        addErrorClass("error-text");
        addErrorClass("_error_", !0);
      } else if (password!=password1) {
        showError1("两次密码输入不一致");
        addErrorClass("_password_");
        addErrorClass("_error1_", !0);
      }else{
          // this.phone_num=mobile;
          this.$router.push({
          path: `/`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notclick {
    pointer-events: none; 
}
.error-text {
  color: red;
  text-align: center;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
}
.login_bg {
  width: 484px;
  height: 505px;
  margin: 114px auto 0;
  background: url("../assets/login_bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 24px 61px 75px;
  box-sizing: border-box;
  position: relative;
  // display: none;
}
h3 {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  margin-top: 51px;
}
.input {
  margin-top: 25px;
}
.get-code {
  color: #2479ED;
  position: absolute;
  padding-left: 10px;
  border-left: 1px solid gray;
  font-size: 13px;
  top: 210px;
  left: 310px;
  cursor: pointer;
}
.login_btn {
  margin-top: 5px;
  margin-bottom: 18px;
  width: 100%;
  height: 40px;
  background: url("../assets/login_btn_bg.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}
.return_login{
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin-top: 66px;
  cursor: pointer;
}
.confirm_password {
  width: 484px;
  height: 505px;
  margin: 114px auto 0;
  background: url("../assets/login_bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 24px 61px 75px;
  box-sizing: border-box;
  position: relative;
  display: none;
}
</style>
